/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Team_AllInputs */

const en_landing_team_all = /** @type {(inputs: Landing_Team_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet the team`)
};

const pl_landing_team_all = /** @type {(inputs: Landing_Team_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznaj zespół`)
};

/**
* | output |
* | --- |
* | "Meet the team" |
*
* @param {Landing_Team_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_team_all = /** @type {((inputs?: Landing_Team_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Team_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_team_all(inputs)
	return en_landing_team_all(inputs)
});